<div class="flex justify-content-between pt-4 pb-3">
  <div class="flex">
      <span class="p-float-label">
        <input
          [(ngModel)]="assetFilters.alias"
          (keyup.enter)="applyFilters()"
          type="text"
          id="alias"
          pInputText
        >
        <label for="alias">{{'attribute.alias' | transloco}}</label>
      </span>
    <span class="p-float-label ml-2">
      <input
        [(ngModel)]="assetFilters.description"
        (keyup.enter)="applyFilters()"
        type="text"
        id="description"
        pInputText
      >
      <label for="description">{{'attribute.description' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem" *ngIf="representations">
      <p-multiSelect
        [(ngModel)]="assetFilters.representationNames"
        [options]="representations"
        [filter]="true"
        styleClass="w-full"
        optionLabel="value"
        optionValue="value"
        inputId="representation"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.assetRepresentation' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
      <p-multiSelect
        [(ngModel)]="assetFilters.organizationUuids"
        [options]="organizations"
        [filter]="true"
        styleClass="w-full"
        optionLabel="name"
        optionValue="uuid"
        inputId="organization"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.organization' | transloco}}</label>
    </span>
  </div>
  <div>
    <button
      [label]="'common.search' | transloco"
      (click)="applyFilters()"
      pButton
      icon="pi pi-search"
      iconPos="right"
    ></button>
  </div>
</div>

<p-table
  [(selection)]="assetSelection"
  [(first)]="first"
  [(rows)]="rows"
  [value]="assets"
  [totalRecords]="totalAssets"
  [paginator]="true"
  [autoLayout]="true"
  [sortField]="assetFilters.sortField"
  [sortOrder]="assetFilters.sortOrder"
  [lazy]="true"
  (onLazyLoad)="onAssetPageChange($event)"
  (selectionChange)="assetSelectionChange.emit(assetSelection)"
  responsiveLayout="stack"
  styleClass="p-datatable-striped"
  dataKey="uuid"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="w-3rem">
        <button
          *ngIf="selectionMode === 'multiple'"
          [class.p-button-danger]="totalAssets > 100"
          [pTooltip]="'error.tooMany.assetsSelectAll' | transloco: { elements: totalAssets }"
          [tooltipDisabled]="totalAssets <= 100"
          (click)="totalAssets <= 100 ? displaySelectAllDialog() : ''"
          pButton
          pRipple
          icon="pi pi-check-square"
          class="p-button-icon-only p-button-text p-0 w-auto p-button-lg"
        ></button>
      </th>
      <th pSortableColumn="alias">
        {{'attribute.alias' | transloco}}
        <p-sortIcon field="alias"></p-sortIcon>
      </th>
      <th pSortableColumn="description">
        {{'attribute.description' | transloco}}
        <p-sortIcon field="description"></p-sortIcon>
      </th>
      <th pSortableColumn="assetRepresentation.name">
        {{'model.assetRepresentation' | transloco}}
        <p-sortIcon field="assetRepresentation.name"></p-sortIcon>
      </th>
      <th pSortableColumn="organization.name" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
        {{'model.organization' | transloco}}
        <p-sortIcon field="organization.name"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-asset>
    <ng-component *ngIf="loadingAssets then skeletonRow else dataRow"></ng-component>
    <ng-template #dataRow>
      <tr>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'common.select' | transloco}}</span>
          <p-tableRadioButton *ngIf="selectionMode === 'single'" [value]="asset"></p-tableRadioButton>
          <p-tableCheckbox *ngIf="selectionMode === 'multiple'" [value]="asset"></p-tableCheckbox>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
          <a [href]="'/assets/' + asset.uuid + '/details'" target="_blank">{{asset.alias}}</a>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          <p class="text-right md:text-left">{{asset.description}}</p>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'model.assetRepresentation' | transloco}}</span>
          <p class="text-right md:text-left">{{asset.assetRepresentation ? asset.assetRepresentation.name : ''}}</p>
        </td>
        <td class="h-3rem py-0" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
          <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
          <p class="text-right md:text-left">{{asset.organization ? asset.organization.name : ''}}</p>
        </td>
      </tr>
    </ng-template>
    <ng-template #skeletonRow>
      <tr>
        <td class="h-3rem py-0">
          <p-skeleton height="1em"></p-skeleton>
        </td>
        <td class="h-3rem py-0">
          <p-skeleton height="1em"></p-skeleton>
        </td>
        <td class="h-3rem py-0">
          <p-skeleton height="1em"></p-skeleton>
        </td>
        <td class="h-3rem py-0">
          <p-skeleton height="1em"></p-skeleton>
        </td>
        <td class="h-3rem py-0" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
          <p-skeleton height="1em"></p-skeleton>
        </td>
      </tr>
    </ng-template>
  </ng-template>
</p-table>

